import { attributionConsent } from "./consent.js";

import { isAcquisitionPage } from "./acquisitionAttribution.js";

export function isConsentPage(path) {
  const normalized = path.replace(/\/$/, "").replace(/\.html$/, "") || "/";
  return !normalized.startsWith("/app") && !normalized.startsWith("/on-boarding") && isAcquisitionPage(normalized);
}

const instances = new WeakMap();
const CSS = `
#ap-traffic-consent-root .ap-tc-intro{display:grid;grid-template-columns:minmax(0,1fr) auto;gap:24px;align-items:center}
#ap-traffic-consent-root .ap-tc-preferences{position:fixed;inset:0;width:calc(100% - 32px);max-width:560px;max-height:calc(100dvh - 32px);margin:auto;padding:32px;overflow:auto;overscroll-behavior:contain;border:1px solid #083e5b26;border-radius:16px;background:#fff;color:#083e5b;box-shadow:0 16px 64px #083e5b26}
#ap-traffic-consent-root .ap-tc-preferences::backdrop{background:rgb(8 62 91 / 35%)}
#ap-traffic-consent-root .ap-tc-preferences .ap-tc-actions{margin-top:20px}
#ap-traffic-consent-root .ap-tc-setting{display:flex;align-items:center;gap:24px;justify-content:space-between;padding:14px 0;border-top:1px solid #083e5b26}
#ap-traffic-consent-root .ap-tc-source-setting{display:grid;grid-template-columns:minmax(0,1fr) auto;gap:6px 24px}
#ap-traffic-consent-root .ap-tc-source-setting label{align-self:baseline;margin:0}
#ap-traffic-consent-root #ap-tc-source-optional{justify-self:end;align-self:baseline;white-space:nowrap;font-weight:600}
#ap-traffic-consent-root .ap-tc-source-setting #ap-tc-source{justify-self:end}
#ap-traffic-consent-root .ap-tc-setting strong{font-size:14px}
#ap-traffic-consent-root .ap-tc-always{white-space:nowrap;font-size:12px;font-weight:600}
#ap-traffic-consent-root #ap-tc-source{appearance:none;flex:0 0 48px;width:48px;height:28px;margin:8px 0;border:2px solid #526873;border-radius:20px;background:#e5eaed;cursor:pointer;position:relative}
#ap-traffic-consent-root #ap-tc-source:before{content:"";position:absolute;left:3px;top:3px;width:18px;height:18px;border-radius:50%;background:#526873}
#ap-traffic-consent-root #ap-tc-source:checked{background:#fcc455!important;border-color:#fcc455!important}
#ap-traffic-consent-root #ap-tc-source:checked:before{left:23px;background:#083e5b}
#ap-traffic-consent-root #ap-tc-source:focus-visible{outline:3px solid #083e5b;outline-offset:3px}

[data-ap-traffic-preferences][hidden]{display:none!important}
#ap-traffic-consent-root{position:relative;z-index:100000;font-family:Montserrat,Arial,sans-serif;color:#083e5b;line-height:1.55;font-size:14px;text-align:left}
#ap-traffic-consent-root *{box-sizing:border-box}
#ap-traffic-consent-root [hidden]{display:none!important}
#ap-traffic-consent-root .ap-tc-card{position:fixed;left:24px;right:24px;bottom:24px;width:auto;max-width:none;display:grid;grid-template-columns:minmax(0,1fr) auto;column-gap:32px;align-items:center;max-height:calc(100dvh - 48px);overflow:auto;background:#fff;border:1px solid #083e5b26;border-radius:12px;padding:24px;box-shadow:0 2px 8px #083e5b0d}
#ap-traffic-consent-root h2{margin:0 0 6px;font:600 17px/1.4 Montserrat,Arial,sans-serif;color:#083e5b;letter-spacing:normal}
#ap-traffic-consent-root p{margin:0 0 6px;font:400 13px/1.6 Montserrat,Arial,sans-serif;color:#083e5b}
#ap-traffic-consent-root .ap-tc-note{font-size:12px}
#ap-traffic-consent-root .ap-tc-state{font-weight:600}
#ap-traffic-consent-root .ap-tc-actions{display:flex;gap:10px;margin:0}
#ap-traffic-consent-root button{appearance:none;cursor:pointer;min-height:44px;border:1px solid #083e5b;background:#fff;color:#083e5b;border-radius:8px;padding:10px 14px;font:600 13px/1.4 Montserrat,Arial,sans-serif;white-space:normal;text-align:center;margin:0;box-shadow:none;text-transform:none}
#ap-traffic-consent-root .ap-tc-actions button{flex:1 1 100px;min-width:100px}
#ap-traffic-consent-root button:hover{background:#fcc455;border-color:#fcc455}
#ap-traffic-consent-root button:focus-visible,#ap-traffic-consent-root a:focus-visible{outline:3px solid #083e5b;outline-offset:3px}
#ap-traffic-consent-root a{color:#083e5b;text-decoration:underline;font:500 12px/1.5 Montserrat,Arial,sans-serif}
#ap-traffic-consent-root .ap-tc-footer{display:flex;align-items:center;justify-content:space-between;gap:12px}
#ap-traffic-consent-root .ap-tc-close{border:0;text-decoration:underline;padding:8px;min-width:60px}
#ap-traffic-consent-space{display:block;height:var(--ap-traffic-consent-space,0px);width:100%;pointer-events:none}
@media(max-width:760px){
#ap-traffic-consent-root .ap-tc-intro{display:block}
#ap-traffic-consent-root .ap-tc-preferences{padding:20px}
#ap-traffic-consent-root .ap-tc-card{left:16px;bottom:calc(16px + env(safe-area-inset-bottom,0px));width:calc(100vw - 32px);max-width:none;display:block;max-height:calc(100dvh - 32px - env(safe-area-inset-bottom,0px));padding:20px}
#ap-traffic-consent-root h2{font-size:17px}
#ap-traffic-consent-root .ap-tc-actions{margin-top:14px}
#ap-traffic-consent-root .ap-tc-actions button{flex:auto;width:100%}
}
@media(prefers-reduced-motion:no-preference){#ap-traffic-consent-root button{transition:background-color .15s}}
`;

export function mountTrafficConsent({ window = globalThis.window, document = globalThis.document, consent = attributionConsent, isAuthenticated = () => false, subscribeSession = () => () => { } } = {}) {
  if (!document?.createElement) return null;
  if (instances.has(document)) return instances.get(document);
  let root, card, status, spacer, resize, observer, intro, preferences, toggle;
  let opened = false;
  let view = "intro";
  let draft;
  let lastDecision;
  let returnFocus;
  let fromSettings = false;
  let scrollStyles;
  function syncModal(visible) {
    if (visible && !preferences.open) {
      scrollStyles = [document.documentElement.style.overflow, document.body.style.overflow];
      document.documentElement.style.overflow = "hidden";
      document.body.style.overflow = "hidden";
      preferences.showModal();
    } else if (!visible && preferences.open) {
      preferences.close();
      [document.documentElement.style.overflow, document.body.style.overflow] = scrollStyles;
      scrollStyles = undefined;
    }
  }
  function back() {
    if (fromSettings) { opened = false; view = "intro"; render(); focusSettings(); }
    else { showView("intro"); root.querySelector(".ap-tc-manage").focus({ preventScroll: true }); }
  }
  let disposed = false;
  const moved = new Map();

  function restoreOverlays() {
    for (const [element, bottom] of moved) element.style.bottom = bottom;
    moved.clear();
  }
  function layout() {
    if (!root || disposed) return;
    const height = card.hidden ? 0 : Math.ceil(card.getBoundingClientRect().height) + 48;
    spacer.style.setProperty("--ap-traffic-consent-space", height + "px");
    restoreOverlays();
    if (card.hidden) return;
    const bounds = card.getBoundingClientRect();
    for (const element of document.querySelectorAll(".whatsapp-block, #whatsapp-button, .livechat-button-2")) {
      const box = element.getBoundingClientRect();
      if (!box.width || !box.height || box.right <= bounds.left || box.left >= bounds.right || box.bottom <= bounds.top) continue;
      if (window.getComputedStyle(element).position !== "fixed") continue;
      moved.set(element, element.style.bottom);
      element.style.bottom = (window.innerHeight - bounds.top + 12) + "px";
    }
  }
  function eligible() { return !isAuthenticated() && isConsentPage(window.location.pathname); }
  function focusSettings() {
    if (returnFocus?.isConnected && returnFocus.getClientRects().length) returnFocus.focus({ preventScroll: true });
    else document.querySelector("[data-ap-traffic-preferences]:not([hidden])")?.focus({ preventScroll: true });
  }
  function render() {
    if (!root || disposed) return;
    const state = consent.getState();
    if (state !== lastDecision) { draft = state === "granted"; lastDecision = state; }
    const guest = eligible();
    if (!guest) opened = false;
    const visible = guest && (state === "unknown" || opened);
    card.hidden = !visible || view === "preferences";
    for (const link of document.querySelectorAll("[data-ap-traffic-preferences]")) link.hidden = !guest;
    intro.hidden = view !== "intro";
    syncModal(visible && view === "preferences");
    card.style.display = card.hidden ? "none" : "block";
    card.setAttribute("aria-labelledby", view === "intro" ? "ap-tc-heading" : "ap-tc-preferences-heading");
    if (draft === undefined) draft = state === "granted";
    toggle.checked = draft;
    status.hidden = state === "unknown";
    status.textContent = state === "granted" ? "Current choice: Accepted" : "Current choice: Declined";
    layout();
  }
  function open(trigger) {
    if (!eligible()) return;
    returnFocus = trigger || document.activeElement;
    fromSettings = true;
    opened = true;
    draft = consent.hasConsent();
    showView("preferences");
  }
  function finish(decision) {
    opened = false;
    view = "intro";
    draft = undefined;
    consent.setDecision(decision);
    render();
    focusSettings();
  }
  function showView(next) {
    view = next;
    render();
    root.querySelector(next === "intro" ? "#ap-tc-heading" : "#ap-tc-preferences-heading")?.focus({ preventScroll: true });
  }
  function onSettings(event) {
    const trigger = event.target?.closest?.("[data-ap-traffic-preferences]");
    if (!trigger) return;
    event.preventDefault();
    open(trigger);
  }
  function mount() {
    if (root || disposed || !document.body) return;
    root = document.createElement("div");
    root.id = "ap-traffic-consent-root";
    const style = document.createElement("style");
    style.textContent = CSS;
    root.append(style);
    const content = document.createElement("div");
    content.innerHTML = `
      <section class="ap-tc-card" role="region" aria-labelledby="ap-tc-heading">
        <div class="ap-tc-intro">
          <div><h2 id="ap-tc-heading" tabindex="-1">This website uses cookies</h2>
          <p>We use cookies to keep the website working and remember your preferences. With your permission, we also remember how you found Africa's Pocket and the marketing pages you visit before signing up.</p>
</div>
          <div class="ap-tc-actions">
            <button type="button" data-ap-consent="granted">Accept All</button>
            <button type="button" class="ap-tc-manage">Manage preferences</button>
          </div>
        </div>
      </section>
        <dialog class="ap-tc-preferences" aria-labelledby="ap-tc-preferences-heading" aria-describedby="ap-tc-preferences-description">
          <h2 id="ap-tc-preferences-heading" tabindex="-1">Cookie preferences</h2>
          <p id="ap-tc-preferences-description">Choose which optional cookies you're comfortable with. You can sign up whichever option you choose.</p>
          <div class="ap-tc-setting"><div><strong>Essential</strong><p>These cookies help the website work and remember your cookie choice.</p></div><span class="ap-tc-always">Always on</span></div>
          <div class="ap-tc-setting ap-tc-source-setting"><label for="ap-tc-source"><strong>How you found us</strong></label><span id="ap-tc-source-optional" class="ap-tc-note">Optional</span><p id="ap-tc-source-description">These cookies remember the link or website that brought you to Africa's Pocket for up to 90 days. If you sign up, we connect that information to your account.</p><input type="checkbox" role="switch" id="ap-tc-source" aria-describedby="ap-tc-source-optional ap-tc-source-description"></div>
          <p class="ap-tc-state" aria-live="polite"></p>
          <div class="ap-tc-actions"><button type="button" class="ap-tc-save">Save preferences</button><button type="button" class="ap-tc-back">Back</button></div>
        </dialog>`;
    root.append(content);
    card = root.querySelector(".ap-tc-card");
    intro = root.querySelector(".ap-tc-intro");
    preferences = root.querySelector(".ap-tc-preferences");
    toggle = root.querySelector("#ap-tc-source");
    status = root.querySelector(".ap-tc-state");
    toggle.addEventListener("change", () => { draft = toggle.checked; });
    root.querySelector('[data-ap-consent="granted"]').addEventListener("click", () => finish("granted"));
    root.querySelector(".ap-tc-manage").addEventListener("click", () => { fromSettings = false; returnFocus = document.activeElement; showView("preferences"); });
    root.querySelector(".ap-tc-back").addEventListener("click", back);
    root.querySelector(".ap-tc-save").addEventListener("click", () => finish(draft ? "granted" : "denied"));
    preferences.addEventListener("cancel", (event) => { event.preventDefault(); back(); });
    preferences.addEventListener("keydown", (event) => {
      if (event.key !== "Tab") return;
      const items = [...preferences.querySelectorAll("button, input")];
      const first = items[0], last = items.at(-1);
      if (event.shiftKey && (document.activeElement === first || document.activeElement.id === "ap-tc-preferences-heading")) { event.preventDefault(); last.focus(); }
      else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
    });
    spacer = document.createElement("div");
    spacer.id = "ap-traffic-consent-space";
    spacer.setAttribute("aria-hidden", "true");
    document.body.append(spacer, root);
    try { resize = new window.ResizeObserver(layout); resize.observe(card); } catch { /* Window resize remains available. */ }
    render();
  }
  const unsubscribe = consent.subscribe(render);
  const unsubscribeSession = subscribeSession(render);
  try {
    observer = new window.MutationObserver((records) => {
      if (records.some(record => [...record.addedNodes].some(node => node.nodeType === 1 && (node.matches?.("[data-ap-traffic-preferences]") || node.querySelector?.("[data-ap-traffic-preferences]"))))) render();
    });
    observer.observe(document.documentElement, { childList: true, subtree: true });
  } catch { /* Explicit refresh remains available. */ }
  document.addEventListener("click", onSettings);
  document.addEventListener("DOMContentLoaded", mount);
  window.addEventListener("resize", layout);
  const api = {
    open: () => { mount(); open(); },
    refresh: render,
    dispose() {
      if (preferences) syncModal(false);
      disposed = true;
      unsubscribe();
      unsubscribeSession();
      observer?.disconnect();
      resize?.disconnect();
      restoreOverlays();
      document.removeEventListener("click", onSettings);
      document.removeEventListener("DOMContentLoaded", mount);
      window.removeEventListener("resize", layout);
      root?.remove(); spacer?.remove();
      instances.delete(document);
    },
  };
  instances.set(document, api);
  mount();
  return api;
}
